
import { defineComponent, PropType } from 'vue'
import { User } from '~/types/types'

export default defineComponent({
  name: 'ConfirmDeleteIdP',
  props: {
    viewer: {
      type: Object as PropType<User>,
      required: true
    },
    isDeleting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userEmail: '',
      step: 0
    }
  },
  computed: {
    deletionValid(): boolean {
      return this.viewer.email === this.userEmail
    }
  },
  methods: {
    emitDelete(close: () => void) {
      if (this.deletionValid) {
        this.$emit('delete-idp', { close })
      }
    }
  }
})
